import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import { useUser } from "../../../../app/contexts/user.context";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import OptionsMenu from "./options.menu";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import PrimaryButton from "../../../../app/components/buttons/primary";
import OutlinedButton from "../../../../app/components/buttons/outlined";
import TextButton from "../../../../app/components/buttons/text";
import ViewSiteListModal from "../../../../study.plan.actuals/controls/ViewSiteListModal";

const TopControls = () => {
  const navigate = useNavigate();
  const { id, planId } = useParams();
  const [anchor, setAnchor] = useState(null);
  const [open, setOpen] = useState(false);
  const [remodelViewOpen, setRemodelViewOpen] = useState(false);
  const { clearSimData } = useStudyPlan();
  const { isReadOnlyUser } = useUser();

  const handleClick = (e) => {
    setAnchor(e.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleBackToList = () => {
    clearSimData();
    navigate(`/ctpo/study-plans/${id}`);
  };

  const handleEdit = () => {
    clearSimData();
    navigate(`/ctpo/study-plans/${id}/${planId}/review`);
  };

  return (
    <Container>
      <TextButton onClick={handleBackToList}>
        <ChevronLeftIcon />
        Back to Study Plan List
      </TextButton>

      <ButtonContainer>
        <PrimaryButton onClick={() => setRemodelViewOpen(true)}>
          VIEW SITE LIST
        </PrimaryButton>
        <OutlinedButton onClick={handleEdit}>{
          isReadOnlyUser ? "View Study Plan" : "Edit Study Plan"
        }</OutlinedButton>
        {!isReadOnlyUser && (<ClickAwayListener onClickAway={() => setOpen(false)}>
          <div>
            <PrimaryButton onClick={handleClick}>
              Save As <ArrowDropDownIcon />
            </PrimaryButton>
            <OptionsMenu
              open={open}
              anchor={anchor}
              onClose={() => setOpen(false)}
              onBlur={() => setOpen(false)}
            />
          </div>
        </ClickAwayListener>)}
        <ViewSiteListModal
          remodelViewOpen={remodelViewOpen}
          setRemodelViewOpen={setRemodelViewOpen}
        />
      </ButtonContainer>
    </Container>
  );
};

export default TopControls;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  grid-gap: 1em;
`;
